var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"icone",attrs:{"slot":"activator","title":"Remover"},on:{"click":function($event){return _vm.$emit('excluir')}},slot:"activator"},[_c('v-icon',[_vm._v("delete")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }